import Button, { ButtonProps } from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";

function AccentButton({
  children,
  ...props
}: ButtonProps & { target?: string }) {
  const theme = useTheme();

  return (
    <Button
      sx={{
        px: 2,
        bgcolor:
          theme.palette.mode === "dark" ? "primary.main" : "secondary.main",
        color: "#FFFFFF",
        textTransform: "none",
        "&:hover": {
          bgcolor:
            theme.palette.mode === "dark"
              ? theme.palette.primary.dark
              : theme.palette.secondary.dark,
        },
        "&.Mui-disabled": {
          color: "white",
          opacity: 0.9, //dim to indicate it's disabled
        },
      }}
      {...props}
    >
      {children}
    </Button>
  );
}

export { AccentButton };
